if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      };

      this.mql = window.matchMedia('(min-width: 750px)');

      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener(
        'slideChanged',
        debounce(this.onSlideChanged.bind(this), 500)
      );

      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener(
          'click',
          this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)
        );
      });

      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) {
        this.removeListSemantic();
      }
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(
        `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
      );

      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(
        `[data-media-id="${mediaId}"]`
      );

      if (!activeMedia) return;

      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

          if (activeThumbnail) {
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
        }

        if (this.elements.viewer.slider) {
          this.elements.viewer.resetPages();
        }
      }

      this.preventStickyHeader();

      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({
            left: activeMedia.offsetLeft
          });
        }

        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      });

      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;

      const activeThumbnail = this.elements.thumbnails.querySelector(
        `[data-target="${mediaId}"]`
      );

      this.setActiveThumbnail(activeThumbnail);

      if (activeThumbnail) {
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => {
        element.removeAttribute('aria-current');
      });

      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({
        left: thumbnail.offsetLeft
      });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');

      if (!image || !this.elements.liveRegion) return;

      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);

        this.elements.liveRegion.innerHTML =
          window.accessibilityStrings.imageAvailable.replace('[index]', position);

        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };

      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();

      const deferredMedia = activeItem.querySelector('.deferred-media');

      if (deferredMedia) {
        deferredMedia.loadContent(false);
      }
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');

      if (!this.stickyHeader) return;

      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;

      this.elements.viewer.slider.setAttribute('role', 'presentation');

      this.elements.viewer.sliderItems.forEach((slide) => {
        slide.setAttribute('role', 'presentation');
      });
    }
  });
}

function enableMobileVideoAutoplay() {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
      let video = target.querySelector('video');

      if (!isIntersecting || intersectionRatio < 0.5) {
        if (video) video.pause();
        return;
      }

      if (!video) {
        target.loadContent(false);
        video = target.querySelector('video');
      }

      if (!video) return;

      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      if (!video.dataset.tapControlsReady) {
        video.dataset.tapControlsReady = 'true';
        video.controls = false;
        video.tabIndex = 0;

        // Show controls when tapped.
        video.addEventListener('click', () => {
          video.controls = true;
        });

        // Keep controls accessible to keyboard users.
        video.addEventListener('focus', () => {
          video.controls = true;
        });
      }

      video.play().catch(() => {
        // Allow manual playback if the browser blocks autoplay.
        if (isIntersecting && intersectionRatio >= 0.5) {
          video.controls = true;
        }
      });
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('.product__media-list deferred-media').forEach((media) => {
    const template = media.querySelector('template');

    if (template?.content.querySelector('video')) {
      observer.observe(media);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enableMobileVideoAutoplay);
} else {
  enableMobileVideoAutoplay();
}